const convertDomainToApiUrl = (domainUrl) => {
  if (domainUrl === "localhost") {
    return process.env.REACT_APP_HOST;
  }

  try {
    const url = new URL(domainUrl.startsWith('http') ? domainUrl : `https://${domainUrl}`);
    const { hostname } = url;
    
    if (hostname === 'localhost') {
      return process.env.REACT_APP_HOST;
    }
    
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      parts[0] = 'api';
      return `https://${parts.join('.')}/api`;
    }
    
    return domainUrl.startsWith('http') ? domainUrl : `https://${domainUrl}/api`;
  } catch (error) {
    return domainUrl.startsWith('http') ? domainUrl : `https://${domainUrl}/api`;
  }
};

const convertDomainToSocketUrl = (domainUrl) => {
  if (domainUrl === "localhost") {
    return process.env.REACT_APP_SOCKET;
  }
  
  try {
    const url = new URL(domainUrl.startsWith('http') ? domainUrl : `https://${domainUrl}`);
    const { hostname } = url;
    
    if (hostname === 'localhost') {
      return process.env.REACT_APP_SOCKET;
    }
    
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      parts[0] = 'socket';
      return `wss://${parts.join('.')}/socket`;
    }
    
    return domainUrl.startsWith('wss://') ? domainUrl : `wss://${domainUrl}/socket`;
  } catch (error) {
    return domainUrl.startsWith('wss://') ? domainUrl : `wss://${domainUrl}/socket`;
  }
};

const getCurrentDomain = () => window.location.hostname;

export const getBaseApiUrl = () => {
  const currentDomain = getCurrentDomain();
  return convertDomainToApiUrl(currentDomain);
};

export const getBaseSocketUrl = () => {
  const currentDomain = getCurrentDomain();
  return convertDomainToSocketUrl(currentDomain);
};

export const getAPIUrl = () => {
  const currentDomain = getCurrentDomain();
  const apiUrl = convertDomainToApiUrl(currentDomain);
  return apiUrl?.replace(/\/api\/?$/, "");
};
